/**
 * Puerto de cuentas de Medellín Joven (§12.7). Alineado con los endpoints reales
 * `POST /validar-correo`, `POST /validar-documento` y `POST /login` (responden `rowCount`).
 * En el MVP lo implementa un adaptador simulado; en la integración, `HttpCuentasMJ`.
 */
export interface ResultadoVerificacionMJ {
  estado: 'REGISTRADO' | 'NO_REGISTRADO' | 'ERROR_VERIFICACION';
  mjUserId?: number;
  correoMJ?: string;
  nombreMJ?: string;
  celularMJ?: string;
  tipoDocumentoMJ?: string;
  documentoMJ?: string;
  documentoCoincide?: boolean;
  documentoTieneCuenta?: boolean;
  correoCoincideConDocumento?: boolean;
  correoDelDocumento?: string;
  correoPerteneceAOtroDocumento?: boolean;
  documentoDelCorreo?: string;
  detalle?: string;
}

export interface SesionMJ {
  mjUserId: number;
  nombre: string;
  correo: string;
  documento?: string;
  token: string;
  iniciadaEn: string;
}

export abstract class MedellinJovenCuentasPort {
  abstract verificarCorreo(correo: string, documento?: string): Promise<ResultadoVerificacionMJ>;
  abstract verificarDocumento(documento: string): Promise<ResultadoVerificacionMJ>;
  abstract buscarUsuariosDirectorio(termino: string): Promise<ResultadoVerificacionMJ[]>;
  abstract registrarCuenta(datos: { nombre: string; correo: string; documento: string; password?: string }): Promise<ResultadoVerificacionMJ>;
  abstract iniciarSesion(correo: string, password: string): Promise<SesionMJ | null>;
  abstract sesionActual(): SesionMJ | null;
  abstract cerrarSesion(): void;
}
